import { Component } from 'react'
import moment from 'moment'
import { pluralize } from 'humanize-plus'
import { setCookie } from 'utils/CookieHelpers'
import AccountStatusPane from '../AccountStatusPane'
import AccountCallToActionPane from '../AccountCallToActionPane'
import DriftAPI from 'components/shared/DriftAPI'
import { SALES_INBOX_ID, SALES_USER_ID } from 'constants/ResourcesConstants'

const TEAM_TRIAL_DAYS = 14
const TRIAL_DAILY_SUGGESTION = 'DriftTrialDaily'
const TRIAL_EXPIRED_COPY = <span>Your trial has ended. We hope it was a radical experience.</span>

function pluralizeDays(dayCount) {
  return `${dayCount} ${pluralize(dayCount, 'day')}`
}

export default class TrialMessaging extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dismissed: false,
    }
  }

  handleDismiss = () => {
    setCookie(TRIAL_DAILY_SUGGESTION, true, { expires: moment().endOf('day').toDate() })
    this.setState({ dismissed: true })
  }

  openChatWidget = () => {
    const chatPayload = {
      message: 'Hey there - have any questions about moving forward with the trial? Let me know.',
    }
    if (SALES_INBOX_ID && SALES_USER_ID) {
      chatPayload.inboxId = SALES_INBOX_ID
      chatPayload.sender = { id: SALES_USER_ID }
    }
    DriftAPI.showWelcomeMessage(chatPayload)
  }

  getExpiration() {
    const { orgProperties: { trialExpiresAt }} = this.props
    return moment(+trialExpiresAt)
  }

  getDaysRemaining = () => {
    const expirationMoment = this.getExpiration()
    const remainingDuration = moment.duration(expirationMoment.diff(moment()))
    return Math.floor(remainingDuration.asDays())
  }

  isTrialExpired() {
    const expirationMoment = this.getExpiration()
    return expirationMoment.isBefore()
  }

  renderTrialInProgressCopy() {
    const daysLeft = this.getDaysRemaining()
    return (
      <span>
        You have {daysLeft} {pluralize(daysLeft, 'day')} remaining in your free trial.
      </span>
    )
  }

  render() {
    const { dismissed } = this.state
    const { currentPath } = this.props
    if (currentPath !== '/home' || dismissed) {
      return false
    }
    const daysSoFar = TEAM_TRIAL_DAYS - this.getDaysRemaining()
    const quotaPercentage = Math.floor(daysSoFar / TEAM_TRIAL_DAYS * 100)
    const callToActionCopy = this.isTrialExpired()
      ? TRIAL_EXPIRED_COPY
      : this.renderTrialInProgressCopy()
    return (
      <div className="notification-bar">
        <AccountStatusPane
          planTitle="Trial Plan"
          planDescription="Free Trial"
          counters={[
            {
              title: `${pluralizeDays(TEAM_TRIAL_DAYS - daysSoFar)} to go!`,
              description: quotaPercentage,
            },
          ]}
        />
        <AccountCallToActionPane
          ctaTitle={callToActionCopy}
          ctaDescription="You currently have access to everything in the Pro plan. Loving it so far? Talk to us to upgrade your account. "
          buttonLabel="Talk to us"
          handleClick={this.openChatWidget}
          handleDismiss={this.handleDismiss}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/GlobalNotificationBar/components/TrialMessaging/index.js